// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import trash02Icon from "@/assets/icons/trash-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Trash02IconProps = Omit<IconProps, "name">;

export function Trash02Icon(props: Trash02IconProps): React.ReactNode {
  return <Icon name={trash02Icon} {...props} />;
}
